export default __webpack_public_path__ + "static/media/import-data-template.c48b9dd3.xlsx";